import axios from 'axios';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { endpointApi } from '../utils';
import { useLocation, useNavigate } from 'react-router-dom';
import { logout } from '../redux/actions/auth.action';
import { useDispatch } from 'react-redux';

export default function SearchBambou({ updateBambou=null, defaultValue=null, required=false, id="bambou_id", reset=false }) {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const autocompleteListRef = useRef(null);
    const autocompleteInputRef = useRef(null);
    const [isAutocompleteOpen, setIsAutocompleteOpen] = useState(false);
    const [q, setQ] = useState("");
    const [bambou, setBambou] = useState(defaultValue);
    const [bambous, setBambous] = useState([]);
    const [isTouched, setIsTouched] = useState(false);

    const searchBambous = useCallback(async (q=null) => {
        try {
            const jwt_access = localStorage.getItem('jwt_access');
            const { data } = await axios.get(`${ endpointApi }bambous/search${ q ? '?q=' + q : '' }`, {
                headers: {
                    'Authorization': `Bearer ${ jwt_access }`
                }
            });
            setBambous(data);
        } catch (err) {
            if(err.response.status === 401){
                dispatch(logout(location.pathname + location.search, navigate));
            }
        }
    }, [dispatch, navigate, location]);

    useEffect(() => {
        searchBambous();
    }, [searchBambous, location]);

    useEffect(() => {
        if(reset)
            setIsTouched(false);
    }, [reset]);

    useEffect(() => {
        if(q.length >= 2){
            searchBambous(q);
        }
    }, [searchBambous, q]);
    
    useEffect(() => {
        setQ("");
        if(updateBambou && bambou){
            updateBambou(bambou);
        }
    }, [updateBambou, bambou]);

    useEffect(() => {
        setBambou(defaultValue);
    }, [defaultValue]);

    useEffect(() => {
        const clickOutsiteAutocompleteList = (e) => {
            if(autocompleteInputRef.current && e.target !== autocompleteInputRef.current && autocompleteListRef.current && !autocompleteListRef.current.contains(e.target) && autocompleteListRef.current.classList.contains('active')){
                setIsAutocompleteOpen(false);
            }
        }
        document.addEventListener('click', clickOutsiteAutocompleteList);
        return () => {
            document.removeEventListener('click', clickOutsiteAutocompleteList);
        }
    }, []);

    return (
        <>
            <div className='autocomplete'>
                <label htmlFor={ id } className='form-control'>{ bambou ? "Bambou " + bambou.code : 'Rechercher bambou' }</label>
                <input type='text' ref={ autocompleteInputRef } id={ id } onFocus={ () => {
                    setIsAutocompleteOpen(true);
                }} placeholder={ bambou ? "Bambou " + bambou.code : 'Rechercher bambou' } className='form-control' value={ q } onChange={ (e) => setQ(e.target.value) } onBlur={ () => setIsTouched(true) } />
                <ul className={ `autocomplete-list${ isAutocompleteOpen ? ' active' : '' }` } ref={ autocompleteListRef }>
                    { bambous.map(item => {
                        return(
                            <li key={ item.id } onClick={ () => {
                                setBambou(item);
                                setIsAutocompleteOpen(false);
                            } }><i className='fa fa-search'></i> Bambou { item.code }</li>
                        )
                    }) }
                    { bambous.length === 0 && <li className='empty'>Aucun résultat trouvé</li> }
                </ul>
            </div>
            { isTouched && required && bambou === null && <div className='form-error'>Veuillez sélectionner le bambou.</div> }
        </>
    )
}
